import axios from 'axios'
import { ADMIN_API_URL } from 'const'

export const getStatus = async () => {
  try {
    const { data } = await axios.get(`${ADMIN_API_URL}/slack/status`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const authorize = async (channelCid) => {
  try {
    const { data } = await axios.post(`${ADMIN_API_URL}/slack/authorize`, {
      channel_cid: channelCid ?? null,
    })
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const completeCallback = async (code, state) => {
  try {
    const { data } = await axios.post(`${ADMIN_API_URL}/slack/callback`, {
      code,
      state,
    })
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const disconnect = async () => {
  try {
    await axios.delete(`${ADMIN_API_URL}/slack/link`)
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const getSubscriptions = async () => {
  try {
    const { data } = await axios.get(`${ADMIN_API_URL}/chat/subscriptions`)
    return data.subscribed_channel_cids
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const subscribe = async (channelCid) => {
  try {
    const { data } = await axios.post(`${ADMIN_API_URL}/chat/subscriptions`, {
      channel_cid: channelCid,
    })
    return data.subscribed_channel_cids
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const unsubscribe = async (channelCid) => {
  try {
    const { data } = await axios.delete(
      `${ADMIN_API_URL}/chat/subscriptions/${encodeURIComponent(channelCid)}`
    )
    return data.subscribed_channel_cids
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}
